import React from 'react';
var ComponentOverridesContext = /*#__PURE__*/React.createContext({});
ComponentOverridesContext.displayName = 'ComponentOverridesContext';
var ComponentOverridesConsumer = ComponentOverridesContext.Consumer;
var ComponentOverridesProvider = ComponentOverridesContext.Provider;
var useComponentOverridesProvider = () => React.useContext(ComponentOverridesContext);

// @ts-expect-error Provider does not have a displayName in types
ComponentOverridesProvider.displayName = 'ComponentOverridesProvider';
export { ComponentOverridesConsumer, ComponentOverridesProvider, useComponentOverridesProvider };
//# sourceMappingURL=index.js.map